import { Link } from "react-router";
import {
    MagnifyingGlassIcon,
    Bars3BottomLeftIcon,
    CalendarIcon,
} from "@heroicons/react/24/outline";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

function HowItWorks() {
    return (
        <div className="flex h-full px-4 pt-6 pb-24 md:px-10">
            <div className="container mx-auto md:pt-15">
                <div className="mx-auto prose max-w-4xl prose-darkgreen">
                    <p className="text-center text-sm font-medium tracking-[0.32em] text-neutral-400 uppercase">
                        CALM BY DESIGN
                    </p>

                    <h1 className="mb-4 text-center text-6xl font-semibold tracking-wider">
                        Care in three simple steps.
                    </h1>

                    <p className="lead mx-auto mb-12 max-w-3xl text-center text-neutral-500">
                        No phone queues, no guesswork. Just a clearer way
                        through.
                    </p>
                </div>
                <div className="mb-12 grid grid-cols-12 gap-x-8 gap-y-12">
                    <div className="col-span-full md:col-span-4">
                        <Card
                            size="lg"
                            className="relative h-full bg-sky-50/25"
                        >
                            <div className="absolute -top-7 left-1/2 flex size-14 shrink-0 -translate-x-1/2 items-center justify-center rounded-full bg-darkgreen-500 text-white shadow-sm/25">
                                <MagnifyingGlassIcon className="size-6 shrink-0 stroke-2" />
                            </div>
                            <p className="mt-8 mb-3 text-center text-2xl font-semibold">
                                Search
                            </p>
                            <p className="text-center text-neutral-500">
                                Tell us what you need and where. Browse verified
                                clinicians by speciality, location and
                                availability.
                            </p>
                        </Card>
                    </div>
                    <div className="col-span-full md:col-span-4">
                        <Card
                            size="lg"
                            className="relative h-full bg-sky-50/25"
                        >
                            <div className="absolute -top-7 left-1/2 flex size-14 shrink-0 -translate-x-1/2 items-center justify-center rounded-full bg-darkgreen-500 text-white shadow-sm/25">
                                <Bars3BottomLeftIcon className="size-6 shrink-0 stroke-2" />
                            </div>
                            <p className="mt-8 mb-3 text-center text-2xl font-semibold">
                                Compare
                            </p>
                            <p className="text-center text-neutral-500">
                                See qualifications, registrations, reviews and
                                real availability, clearly, side by side.
                            </p>
                        </Card>
                    </div>
                    <div className="col-span-full md:col-span-4">
                        <Card
                            size="lg"
                            className="relative h-full bg-sky-50/25"
                        >
                            <div className="absolute -top-7 left-1/2 flex size-14 shrink-0 -translate-x-1/2 items-center justify-center rounded-full bg-darkgreen-500 text-white shadow-sm/25">
                                <CalendarIcon className="size-6 shrink-0 stroke-2" />
                            </div>
                            <p className="mt-8 mb-3 text-center text-2xl font-semibold">
                                Book
                            </p>
                            <p className="text-center text-neutral-500">
                                Confirm in minutes with instant confirmation and
                                reminders. Rebook the people you trust,
                                fee-free.
                            </p>
                        </Card>
                    </div>
                </div>
                <Button variant="primary" className="mx-auto" asChild>
                    <Link to="/clinicians/find">Start your search</Link>
                </Button>
            </div>
        </div>
    );
}

export default HowItWorks;
